import { LogoMark } from "./Logo";

export const Footer = () => (
  <footer id="contacto" data-testid="site-footer" className="border-t border-white/10 mt-10">
    <div className="max-w-[1500px] mx-auto px-4 lg:px-10 py-16 grid gap-10 lg:grid-cols-12 items-end">
      <div className="lg:col-span-8">
        <p className="font-display text-[18vw] lg:text-[11rem] leading-[0.8] text-stroke">T-REX</p>
      </div>
      <div className="lg:col-span-4 flex flex-col gap-4 lg:items-end">
        <LogoMark className="w-12 h-12" />
        <p className="font-mono text-xs uppercase tracking-[0.25em] text-[#A8B3C4]">© {new Date().getFullYear()} DJ T-REX · Official Music</p>
      </div>
    </div>
  </footer>
);
